import { getMenuList } from 'graphql/queries/getHeader';

import { useGraphqlQuery } from '@/hooks/useGraphqlQuery';
import { extractNavMenu } from '@/lib/utils';

export const useNavMenuData = () => {
  const {
    data: navMenuData,
    error: navMenuError,
    loading: isNavMenuLoading,
  } = useGraphqlQuery(false, '', getMenuList, true, 'HEADER');

  const menuSections = navMenuData?.NBJMenuList?.[0]?.menuSections ?? [];

  const [leftMenu, centerMenu, rightMenu] = [
    menuSections[0]?.sectionLinks ?? [],
    extractNavMenu(menuSections[1]?.sectionLinks ?? []),
    extractNavMenu(menuSections[2]?.sectionLinks ?? []),
  ];
  // need to replace POC with search for center menu in NBJmenulists
  return { leftMenu, centerMenu, rightMenu, isNavMenuLoading, navMenuError };
};
